module.exports = __webpack_public_path__ + "static/media/P1-error-404.82d0fad3.png";